import { useMemo } from 'react';
import { Box, Grid } from '@mui/material';
import DrawerContent from 'layout/MainLayout/Drawer/DrawerContent/index';
import DrawerHeader from 'layout/MainLayout/Drawer/DrawerHeader/index';
import { useSelector } from 'react-redux';

const ProfilePage = () => {
    const isLoggedIN = useSelector(state => state.login.data)
    const drawerContent = useMemo(() => <DrawerContent />, [isLoggedIN]);
    const drawerHeader = useMemo(() => <DrawerHeader />, []);

    return (
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={3}>
                    {drawerHeader}
                </Grid>
                <Grid item xs={12} md={9}>
                    {drawerContent}
                </Grid>
            </Grid>
        </Box>
    );
};

export default ProfilePage;